import { render, staticRenderFns } from "./StudentHistoryPeriod.vue?vue&type=template&id=3ffb9673&scoped=true&"
import script from "./StudentHistoryPeriod.vue?vue&type=script&lang=js&"
export * from "./StudentHistoryPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb9673",
  null
  
)

export default component.exports